import { useQuery } from '@tanstack/react-query';

import { voucherCloneQueryKeys } from '~/hooks/apis/promo/voucherCloneQueryKeys';

import { CloneVoucherPreviewQuery, getCloneVoucherPreview } from '~/services/PromoService';

type Params = {
  params: CloneVoucherPreviewQuery | null;
  enabled: boolean;
};

export function useCloneVoucherPreview({ params, enabled }: Params) {
  return useQuery({
    queryKey: params ? voucherCloneQueryKeys.preview(params) : [...voucherCloneQueryKeys.all, 'preview', 'idle'],
    queryFn: async ({ signal }) => getCloneVoucherPreview(params!, { signal }),
    enabled: Boolean(enabled && params && params.newVoucherName.trim().length > 0),
    // Preview calls often return 4xx validation errors; avoid retries hiding the last error.
    retry: false,
  });
}
